<template>

  <section class="application-create__form">
    <div class="container-xxxl">
      <div class="row">
        <div class="col-xxl-6 offset-xxl-3">
          <h3 class="application__form__title space__between">
            {{ $lang.app.DOCUMENTS }}
            <div class="button__dropdown" v-click-outside="() => showVersionDropdown = false">
              <button type="button" class="button button--default button__icon--right button--bordered"
                      @click="showVersionDropdown = !showVersionDropdown">
                {{ $lang.app.VERSION }} {{ documentsVersion.version }}
                <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#chevron__down"></use>
                </svg>
              </button>
              <ul class="dropdown__list dropdown__list--right" :class="{'opened': showVersionDropdown}">
                <li v-for="version in [...application.documentsVersions].reverse()" :key="version.id" class="dropdown__item">
                  <router-link :to="{
                    name: 'ApplicantApplicationDocumentsVersionDetail',
                    params: { applicationId: application.id, documentsVersionId: version.id }}"
                               class="dropdown__link">{{ $lang.app.VERSION }} {{ version.version }}</router-link>
                </li>

                <li class="dropdown__item">
                  <router-link :to="{
                    name: 'ApplicantApplicationDocumentsDetail',
                    params: { applicationId: application.id }}" class="dropdown__link">{{ $lang.app.DOCUMENTS }}</router-link>
                </li>
              </ul>
            </div>
          </h3>
          <div class="application__form__block">
            <div v-if="documentsVersion.edit || documentsVersion.letterFile || documentsVersion.attachmentFiles.length || documentsVersion.remarkComment !== null"
                 class="add__field__item application__official__letter">
              <div v-if="documentsVersion.edit || documentsVersion.remarkComment !== null">
                <div class="add__field__header">
                  {{ $lang.app.REMARKS }}
                </div>
                <div v-if="application.comments.some(item => item.type === commentTypesGetValueByKey('RESOLUTION_REMARKS_TYPE'))">
                  {{ application.comments.findLast(item => item.type === commentTypesGetValueByKey('RESOLUTION_REMARKS_TYPE')).comment }}
                </div>
                <div v-if="documentsVersion.inProcessType">
                  <div class="mb-4">{{ documentsVersion.remarkComment }}</div>
                  <div v-if="documentsVersion.inProcessRemarksFiles.length" class="stack__list">
                    <div class="stack__label">{{ $lang.app.ATTACHED_FILES }}</div>
                    <div v-for="(file, index) in documentsVersion.inProcessRemarksFiles" :key="index"
                         class="flex items-center">
                      <div class="cursor-pointer w-full file__item mb-2"
                           @click="loadInProcessRemarksFile(file)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                          {{ file.filename }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="documentsVersion.rejectReason" class="reply__value">
                    <div class="reply__value__state">{{ $lang.app.CHANGE_IN_PROCESS_REJECTED}}</div>
                    <div class="reply__conclusion__text whitespace-pre-wrap">{{ documentsVersion.rejectReason }}</div>
                  </div>
                </div>
              </div>

              <div v-if="documentsVersion.letterFile" class="stack__list">
                <div class="stack__label">{{ $lang.app.LETTER_FILE }}</div>
                <div class="cursor-pointer file__item" @click.prevent="loadLetterFile">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                    {{ documentsVersion.letterFile.filename }}
                  </span>
                </div>
              </div>
              <div v-if="documentsVersion.attachmentFiles.length" class="stack__list">
                <div class="stack__label">{{ $lang.app.ATTACHED_FILES }}</div>
                <div v-for="(attachmentFile, index) in documentsVersion.attachmentFiles" :key="index"
                     class="cursor-pointer file__item mb-2" @click.prevent="loadAttachmentFile(attachmentFile)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                    {{ attachmentFile.filename }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="!documentsVersion.inProcessType" class="add__field__item application__official__letter">
              <div>
                <div class="add__field__header">
                  {{ $lang.app.REMARKS_CORRECTION }}
                </div>
                <div v-if="documentsVersion.edit && application.comments.some(item => item.type === commentTypesGetValueByKey('RESOLUTION_REMARKS_TYPE'))">
                  {{ application.comments.findLast(item => item.type === commentTypesGetValueByKey('RESOLUTION_REMARKS_TYPE')).comment }}
                </div>
              </div>
              <div v-if="documentsVersion.activeAdditionalFiles.length" class="stack__list">
                <div class="stack__label">{{ $lang.app.CORRECTION_LETTER }}</div>
                <div v-for="(documentsVersionsAdditionalFile, index) in documentsVersion.activeAdditionalFiles" :key="index"
                     class="flex items-center">
                  <div class="cursor-pointer w-full file__item mb-2"
                       @click="loadDocumentsVersionsAdditionalFile(documentsVersion, documentsVersionsAdditionalFile)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                    </svg>
                    <span class="file__item__name">
                    {{ documentsVersionsAdditionalFile.files.filename }}
                  </span>
                  </div>
                  <button v-if="editable" @click="removeDocumentsVersionsAdditionalFile(documentsVersion, documentsVersionsAdditionalFile)"
                          type="button" :title="$lang.app.DELETE" class="text-gray-300 ml-2">
                    <svg class="fill-current" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                    </svg>
                  </button>
                </div>
              </div>
              <button v-if="editable" type="button" class="button button--default button--bordered button--full mb2"
                      @click="$emitter.emit('open-add-documents-version-files-modal', {applicationId: application.id, versionId: documentsVersion.id})">
                <svg class="fill-current icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                </svg>
                {{ $lang.app.CORRECTION_LETTER }}
              </button>
              <button v-if="documentsVersion.signDate === null && documentsVersion.activeAdditionalFiles.length > 0"
                      type="button" class="button button--default button--bordered button--full mb2"
                      @click="$emitter.emit('open-sign-additional-letter-modal', {applicationId: application.id, versionId: documentsVersion.id})">
                {{ $lang.app.SIGN }}
              </button>
              <div v-if="documentsVersion.signDate" class="row">
                <div class="col-lg-4">
                  <div class="signature__panel">
                    <div class="stack__list mb0">
                      <div class="stack__label">{{ $lang.app.SIGNED_DATE }}</div>
                      <div class="stack__value">{{ $moment(documentsVersion.signDate).format('YYYY.MM.DD HH:mm') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-between items-center">
              <h4 class="add__fields__title">{{ $lang.app.DOCUMENT }}</h4>
              <div v-if="editable && !documentsVersion.inProcessType" class="mb-8">
                <button type="button" class="button button--default button--bordered"
                        @click="$emitter.emit('open-applicant-application-document-version-create-modal', application.documents)">
                  <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                  </svg>
                  <span class="button__text">{{ $lang.app.DOCUMENT }}</span>
                </button>
                <button v-if="documents.some(d => d.signDate === null)" type="button"
                        class="button button--default button--bordered ml-4"
                        @click="$emitter.emit('open-sign-all-documents-modal', {applicationId: application.id})">{{ $lang.app.SIGN_ALL }}</button>
              </div>
            </div>

            <div class="add__field__list">
              <div class="row">
                <div v-for="document in documents" :key="document.id" class="w-full">
                  <Collapse class="add__field__item">
                    <template v-slot:title>
                      <div class="add__field__header mb-0">
                        {{ document.docType?.name }}
                      </div>
                    </template>
                    <template v-slot:content>
                      <div>
                        <div v-if="document.surname || document.name || document.patronymic" class="stack__list">
                          <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                          <div class="stack__value">{{ document.surname }} {{ document.name }} {{ document.patronymic }}</div>
                        </div>
                        <div v-if="document.certificateNo" class="stack__list">
                          <div class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</div>
                          <div class="stack__value">{{ document.certificateNo }}</div>
                        </div>
                        <div class="stack__list">
                          <div class="stack__label">{{ $lang.app.FILES }}</div>
                          <div v-for="(docFile, index) in document.documentsFiles" :key="index" class="flex items-center mb-3">
                            <button type="button" class="file__item w-full" @click="loadDocumentFile(document, docFile)">
                              <svg viewBox="0 0 24 24" width="24" height="24">
                                <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                              </svg>
                              <span class="max-w-lg file__item__name break-words">
                              {{ docFile.file.filename }}
                            </span>
                            </button>
                            <button v-if="editable" @click="removeDocumentFile(docFile)" type="button" :title="$lang.app.DELETE" class="text-gray-300 ml-2">
                              <svg class="fill-current" viewBox="0 0 24 24" width="24" height="24">
                                <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                              </svg>
                            </button>
                          </div>
                          <button v-if="editable" type="button" class="button button--default button--bordered button--full mb2"
                                  @click="$emitter.emit('open-add-document-files-modal', {applicationId: application.id, documentId: document.id})">
                            <svg class="fill-current icon" viewBox="0 0 24 24" width="24" height="24">
                              <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                            </svg>
                            {{ $lang.app.ADD_FILE }}
                          </button>
                        </div>
                        <div v-if="document.signDate" class="mb-4">
                          <div class="signature__panel mb1-5">
                            <div class="stack__list mb0">
                              <div class="stack__label">{{ $lang.app.SIGNED_DATE }}</div>
                              <div class="stack__value">{{ $moment(document.signDate).format('YYYY.MM.DD HH:mm') }}</div>
                            </div>
                          </div>
                          <div class="signature__panel">
                            <div class="stack__list mb0">
                              <div class="stack__label">{{ $lang.app.SIGNER }}</div>
                              <div class="stack__value">{{ document.signer }}</div>
                            </div>
                          </div>
                        </div>
                        <button v-else-if="editable && document.documentsFiles.length" type="button"
                                class="button button--default button--bordered button--full mb2"
                                @click="$emitter.emit('open-sign-document-modal', {applicationId: application.id, documentId: document.id})">
                          {{ $lang.app.SIGN_DOCUMENT }}
                        </button>
                        <div>
                          <button v-if="editable" type="button" class="add__field__edit"
                                  @click="$emitter.emit('open-applicant-application-document-version-edit-modal', {documentsVersion, document})">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                            </svg>
                            {{ $lang.app.EDIT }}
                          </button>
<!--                          <button v-if="editable" type="button" @click="removeDocument(document)" :title="$lang.app.DELETE">-->
<!--                            <svg viewBox="0 0 24 24" width="24" height="24">-->
<!--                              <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>-->
<!--                            </svg>-->
<!--                          </button>-->
                        </div>
                      </div>
                    </template>
                  </Collapse>
                </div>
              </div>
            </div>
            <div v-if="editable" class="input__group">
              <button v-if="application.actions.some(item => item.constName === 'IN_PROCESS_REMARK_SEND_ACTION')"
                      type="button" class="button button--default button--bordered"
                      @click="sendInProcessTypeRemarksToExpertize">
                <span class="button__text">{{ $lang.app.SEND_TO_EXPERTIZE }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SignAdditionalLetterModal />
    <SignDocumentModal/>
    <SignAllDocumentsModal/>
    <AddDocumentFilesModal/>
    <AddDocumentsVersionFilesModal/>
    <DocumentVersionEditModal/>
    <DocumentVersionCreateModal/>
  </section>
  <div class="application-create__controls">
    <div class="container-fluid">
      <div class="application-create__controls__wrapper">
        <button type="button" class="button button--cancel" @click="$router.go(-1)">{{ $lang.app.CANCEL }}</button>
        <router-link :to="{name: 'ApplicantApplicationAgreementDetail', params: {applicationId: application.id}}" class="button button__icon--right">{{ $lang.app.NEXT }}
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
          </svg>
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>
import applicationApi from "../../../../api/applicant/application";
import SignDocumentModal from "../../../../components/applicant/application/modals/SignDocumentModal";
import SignAllDocumentsModal from "../../../../components/applicant/application/modals/SignAllDocumentsModal";
import AddDocumentFilesModal from "../../../../components/applicant/application/modals/AddDocumentFilesModal";
import AddDocumentsVersionFilesModal from "../../../../components/applicant/application/modals/AddDocumentsVersionFilesModal";
import SignAdditionalLetterModal from "../../../../components/applicant/application/modals/SignAdditionalLetterModal";
import {getValueByKey as commentTypesGetValueByKey} from "../../../../helpers/constants/commentTypes";
import DocumentVersionEditModal from "../../../../components/applicant/application/modals/DocumentVersionEditModal.vue";
import DocumentVersionCreateModal from "../../../../components/applicant/application/modals/DocumentVersionCreateModal.vue";
import Collapse from "../../../../components/Collapse.vue";

export default {
  name: "ApplicantApplicationDocumentsVersionDetail",
  props: {
    application: Object
  },
  components: {
    SignAdditionalLetterModal,
    SignDocumentModal,
    SignAllDocumentsModal,
    AddDocumentFilesModal,
    AddDocumentsVersionFilesModal,
    DocumentVersionEditModal,
    DocumentVersionCreateModal,
    Collapse,
  },
  data() {
    return {
      showVersionDropdown: false,
    }
  },
  computed: {
    documentsVersion() {
      return this.application.documentsVersions.find(version => this.$route.params.documentsVersionId == version.id)
    },
    editable() {
      return this.documentsVersion.edit
    },
    documents() {
      return this.documentsVersion.documents
    }
  },
  methods: {
    commentTypesGetValueByKey,
    loadLetterFile() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getDocumentsVersionLetterFile(this.application.id, this.documentsVersion.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    loadAttachmentFile(file) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getDocumentsVersionAttachmentFile(this.application.id, this.documentsVersion.id, file.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
    loadDocumentFile(document, documentFile) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getDocumentFile(this.application.id, document.id, documentFile.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },

    loadDocumentsVersionsAdditionalFile(documentsVersion, documentsVersionsAdditionalFile) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getDocumentsVersionAdditionalFile(this.application.id, documentsVersion.id, documentsVersionsAdditionalFile.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },

    loadInProcessRemarksFile(file) {
      console.log(file)
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getInProcessRemarksFile(this.application.id, this.documentsVersion.id, file.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },

    removeDocumentFile(documentFile) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteDocumentFile(this.application.id, documentFile.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },

    removeDocumentsVersionsAdditionalFile(documentsVersion, documentsVersionsAdditionalFile) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteDocumentsVersionAdditionalFile(this.application.id, documentsVersion.id, documentsVersionsAdditionalFile.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },

    removeDocument(document) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteDocument(this.application.id, document.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },

    sendInProcessTypeRemarksToExpertize() {
      if (this.documentsVersion.documents.length) {
        applicationApi.sendInProcessTypeRemarksToExpertise(this.application.id, this.documentsVersion.id, this.documentsVersion.documents[0].id)
            .then(() => {
              this.$emitter.emit('refresh-application', {reload: false})
              this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
            })
            .catch(error => {
              this.$snotify.error(error)
            })
      }
    }
  }
};
</script>
